import React, { useState } from "react";

import UserCreationForm from "./UserCreationForm";
import Header from "../component/Header";
import SidebarSuperUser from "../component/SuperUserNavBar";
import SidebarAdminUser from "../component/AdminNavBar";
import SidebarNormalUser from "../component/UserNavBar";
import { Layout } from "antd";
import UserLayout from "../component/Layout";


const ViewPage = () => {
  const [activePage, setActivePage] = useState("welcome"); // Track active page
  //const [isSidebarOpen, setIsSidebarOpen] = useState(true); // Manage sidebar state

  // Retrieve user from localStorage and parse it
  const storedUser = JSON.parse(localStorage.getItem("userRoles")); // Parse JSON
  const loggedInUserRole = storedUser ; // Get role or null
  const roleOptions = {
    SUPERUSER: ["Super User", "Admin User", "Normal User"],
    ADMINUSER: ["Admin User", "Normal User"],
  };
  // Sidebar & Welcome Message Mapping
  const sidebarComponents = {
    superuser: <SidebarSuperUser setActivePage={setActivePage} />,
    adminuser: <SidebarAdminUser setActivePage={setActivePage} />,
    normaluser: <SidebarNormalUser setActivePage={setActivePage} />,
  };

  const welcomeMessages = {
    SUPERUSER: "Welcome, Super User! ",
    ADMINUSER: "Welcome, Admin User! ",
    NORMALUSER: "Welcome, User! ",
  };
  const[isSidebarOpen,setIsSidebarOpen]=useState(true);
const toggleSidebar=()=>{
    setIsSidebarOpen(!isSidebarOpen);
};

  return (
<UserLayout>
        {/* Content Area - Takes Remaining Space */}
      {/*  <div className={'flex-1 transition-all duration-300 p-4 mt-20 ${isSidebarOpen ? ml-22 : ml-16} overflow-y-auto bg-white rounded-[16px] h-[560px]'}>*/}
           <div className="flex-1 transition-all duration-300 p-4 mt-20 bg-white rounded-[16px] h-auto"> 
            {/* Render different components based on activePage */}
            {activePage === "userCreation" && (
              <UserCreationForm
                loggedInUserRole={loggedInUserRole}
                roleOptions={roleOptions}
              />
            )}

            {activePage === "welcome" && (
              <h2 className="text-center text-lg font-semibold">
                {welcomeMessages[loggedInUserRole] || "Welcome!"}
              </h2>
            )}
          </div>
        
</UserLayout>

  );
};

export default ViewPage;
